import CustomButton from '../CustomButton';
import { useNavigate } from 'react-router-dom';
import { checkCompanyCodeAtom } from 'atom/user';
import { useAtom } from 'jotai';
import { ReactComponent as Close } from 'assets/header/close.svg'

const CheckCompany = () => {
    const [checkCompany, setCheckCompany] = useAtom(checkCompanyCodeAtom);
    const navigate = useNavigate();

    const goCompanyCode = () => {
        navigate('/mypage/editCompany')
        setCheckCompany(false)
    }

    return (
        checkCompany ? (
            <div className="relative">
                <div className="z-[3000] fixed inset-0 flex justify-center items-center bg-black bg-opacity-50">
                    <div className="bg-white shadow-lg p-10 rounded-lg w-[600px] tablet:w-96">
                        <div className='relative flex flex-col gap-8 font-semibold'>
                            <p className="text-2xl text-center">
                                사업자 등록증 안내
                            </p>
                            <Close className='top-0 right-0 absolute cursor-pointer' onClick={() => setCheckCompany(false)} />
                            <div className='flex flex-col gap-3 text-lg text-left'>
                                <p>
                                    원활한 서비스 이용을 위해 사업자 등록증 등록이 필요합니다.
                                </p>
                                <p>
                                    아래 사업자 등록증 바로가기 버튼을 눌러 사업자 등록증을 등록해주세요
                                </p>
                                <p>
                                    만약, 사업자등록증을 등록했다면 관리자에 승인 이후 사용가능합니다.
                                </p>
                            </div>

                            <CustomButton
                                title={'사업자 등록 페이지 바로가기'}
                                onClick={goCompanyCode}
                                className={'!h-15 bg-primary'}
                            />
                        </div>
                    </div>
                </div>
            </div>
        ) :
            <></>
    )
};

export default CheckCompany;